import React from 'react';
import PropTypes from 'prop-types';
import { Placeholder } from 'semantic-ui-react';

export function Img({ src, alt, ...props }) {
    const [loaded, setLoaded] = React.useState(false);
    const afterLoaded = React.useCallback(() => setLoaded(true), [setLoaded]);

    return (
        <>
            {!loaded && (
                <Placeholder style={{ height: 150, width: '100%' }}>
                    <Placeholder.Image />
                </Placeholder>
            )}
            <img src={src} alt={alt} onLoad={afterLoaded} style={loaded ? {} : { height: 0 }} {...props} />
        </>
    );
}

Img.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string
};

Img.defaultProps = {
    alt: ''
};
